module.exports = __webpack_public_path__ + "media/images/freejobs-image-2c430fcd5243ebd15b3c34b872f2d635.png";